import React from "react";
import { FilterPostsInputs } from "../../types/index.type";
import { SearchDropdownForm, SearchItemConfig } from "src/components/Form/search-dropdown-form";

type PostsSearchProps = {
  updateFilterQuery: (where: FilterPostsInputs) => void;
};

const searchItems = {
  id: {
    type: "input",
    placeholder: "Enter Post Id",
  },
  userId: {
    type: "input",
    placeholder: "Enter User ID...",
  },
  "user role": {
    type: "select",
    placeholder: "All Roles",
    options: [
      { value: "COACH", text: "Coach" },
      { value: "LEARNER", text: "Learner" },
    ],
  },
  type: {
    type: "select",
    placeholder: "All Types",
    options: [
      { value: "POST", text: "Normal Post" },
      { value: "ACTIVITY", text: "Activity" },
      { value: "DUO_THOUGHT", text: "Duo Thought" },
    ],
  },
  visibility: {
    type: "select",
    placeholder: "All Visibility",
    options: [
      { value: "PUBLIC", text: "Public" },
      { value: "FOLLOWINGS", text: "Followings" },
    ],
  },
  space: {
    type: "input",
    placeholder: "Enter a language code, e.g., en or nl",
  },
} satisfies Record<string, SearchItemConfig>;

type SearchKey = keyof typeof searchItems;

export const PostsSearch: React.FC<PostsSearchProps> = ({ updateFilterQuery }) => {
  const handleSubmit = (key: SearchKey, value: string) => {
    let filterValue: any = value === "all" ? undefined : value;
    let filterKey: string = key;

    if (key === "user role") filterKey = "userRole";
    if (key === "space") {
      filterKey = "langCodes";
      filterValue = value ? [value] : undefined;
    }

    updateFilterQuery({
      [filterKey]: filterValue,
    } as FilterPostsInputs);
  };

  return (
    <div className="pt-2 pb-7">
      <SearchDropdownForm searchItems={searchItems} handleSubmit={handleSubmit} />
    </div>
  );
};
